import ScreenName from './ScreenName'
export default ScreenName
